import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/app/theme'
import { ICON_BTN_STYLE } from './popup-style'

/**
 * Topbar light/dark toggle. Sets an explicit preference (Settings exposes
 * the third "system" option via the same store).
 */
export function ThemeToggle() {
  const { resolved, setPreference } = useTheme()
  const next = resolved === 'dark' ? 'light' : 'dark'
  return (
    <button
      type="button"
      className="it-icon-btn it-shell-btn"
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      onClick={() => setPreference(next)}
      style={ICON_BTN_STYLE}
    >
      {resolved === 'dark' ? <Moon size={16} aria-hidden /> : <Sun size={16} aria-hidden />}
    </button>
  )
}
